const faqData = [
  {
    q: '悟空影视是否需要注册才能观看？',
    a: '不需要。悟空影视全部影片均可免费在线观看，无需注册账号、无需登录，打开网站即可即点即播，享受流畅的观影体验。',
  },
  {
    q: '悟空影视的电影画质如何？播放会卡顿吗？',
    a: '悟空影视最新电影全部提供高清甚至4K超清画质。我们采用先进的视频编解码与CDN加速技术，确保在不同网络环境下都能实现流畅播放，无需长时间缓冲等待。',
  },
  {
    q: '悟空影视的影片更新频率是怎样的？',
    a: '悟空影视电影大全每日更新，我们的编辑团队会及时收录最新上线的热门电影、经典佳片以及各类专题合集，片库持续扩增，确保影迷总能发现新鲜内容。',
  },
  {
    q: '可以在手机上观看悟空影视吗？',
    a: '当然可以。悟空影视已完成全面的移动端适配，您可以通过手机浏览器直接访问，支持手势操作与投屏功能，随时随地享受高清观影体验。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-question-line text-2xl text-accent-500"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 font-bold">
            常见问题
          </h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10 ml-11">
          关于悟空影视的常见疑问解答
        </p>

        <div className="max-w-3xl mx-auto flex flex-col gap-4">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className="rounded-lg bg-background-100 border border-background-200/60 p-5"
            >
              <h3 className="text-sm font-semibold text-foreground-200 mb-2">
                {item.q}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}